import isCNPJ, { CNPJ_PATTERN } from "./isCNPJ";
import { CNPJ_ALPHANUMERIC_PATTERN } from "./isCNPJAlphanumeric";
import isCPF, { CPF_PATTERN } from "./isCPF";

const PATTERNS = [CPF_PATTERN, CNPJ_PATTERN, CNPJ_ALPHANUMERIC_PATTERN];

/**
 * Check if a value is a valid CPF or CNPJ (numeric or alphanumeric)
 * Accepts traditional numeric CPFs and CNPJs, as well as new alphanumeric CNPJs (valid from 2026).
 * @example ```js
 * isCPFOrCNPJ('366.418.768-70')
 * //=> true
 *
 * isCPFOrCNPJ('36641876870')
 * //=> true
 *
 * isCPFOrCNPJ('213.198.013-20')
 * //=> false
 *
 * isCPFOrCNPJ('2131201872781')
 * //=> false
 *
 * isCPFOrCNPJ('11111111111')
 * //=> false
 *
 * isCPFOrCNPJ('41142260000189')
 * //=> true
 *
 * isCPFOrCNPJ('45.723.174/0001-10')
 * //=> true
 *
 * isCPFOrCNPJ('AB12CD34EF5602')
 * //=> true
 *
 * isCPFOrCNPJ('AB.12C.D34/EF56-02')
 * //=> true
 *
 * isCPFOrCNPJ('411407182')
 * //=> false
 *
 * isCPFOrCNPJ('11.111.111/1111-11')
 * //=> false
 * ```
 * @param value - A text containing a CPF or CNPJ
 */
const isCPFOrCNPJ = (value: string): boolean => {
  const matches = PATTERNS.map((pattern) => pattern.test(value));

  if (!matches.includes(true)) return false;

  // If it matches CPF pattern, validate as CPF
  if (matches[0]) return isCPF(value);

  // Otherwise, validate as CNPJ (numeric or alphanumeric)
  return isCNPJ(value);
};

export default isCPFOrCNPJ;
